import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'crop-5-4', 'Crop54', [["path",{"d":"M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -10"}]]);